import { EBalconyType, NonEmptyArray } from '../../../../../../../packages/JsonQuery';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectBalconyFilter } from 'shared/selectors/advancedFilters';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';

export const BalconyContainer: FC = () => {
  const { label, value, options } = useSelector(selectBalconyFilter);

  const onChange = useFilterChangeCallback();

  const handleBalconyChange = useCallback(
    (newValue: NonEmptyArray<EBalconyType> | null) => {
      onChange({ action: 'setBalconyTypes', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleBalconyChange} />
    </AdvancedFilterRow>
  );
};
